import { ApolloClient, InMemoryCache } from '@apollo/client/core'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { onError } from "@apollo/client/link/error"

const batchHttpLink = new BatchHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_ENDPOINT,
  batchInterval: 10,
  batchMax: 10,
  batchKey: (operation) => {
    let batchKey = ''

    // For instance queries, support batch key
    if (operation?.operationName?.match(/instanceQuery|pollresponse/)) {
      batchKey = 'instance'
      if (operation.variables?.instanceId) {
        batchKey += `:${operation.variables.instanceId}`
      }
      if (operation.variables?.batchKey) {
        batchKey += `:${operation.variables.batchKey}`
      }
    } else if (operation?.variables?.batchKey) {
      batchKey = operation.variables.batchKey
    }
    return batchKey
  }
})

const errorLink = onError(({ response }) => {
  const message = response?.errors?.[0]?.message
  if (message === undefined) {
    // If no message, there's a network error. Should be caught in individual call
  } else if (message === 'Forbidden') {
    console.log('[ym] unauthorized; returning to login')
    useLogout().logout()
  }
})

// Disable dev tools warning.
window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ = true

const apolloClient = new ApolloClient({
  link: errorLink.concat(batchHttpLink),
  cache: new InMemoryCache(),
  connectToDevTools: false,
  queryDeduplication: false
})

apolloClient.defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache'
  },
  query: {
    fetchPolicy: 'no-cache'
  }
}

export default apolloClient
